/*
 * A&K 10.000
 * Author: Rouven Pajewski
 * Company: ActiView GmbH
 *
 * http://www.actiview.de
 */

import Swiper from 'swiper';

$(document).ready(function() {
    var mainSwiper = new Swiper('.swiper-container-main', {
        pagination: '.swiper-pagination-main',
        paginationClickable: true,
        nextButton: '.swiper-button-next-main',
        prevButton: '.swiper-button-prev-main',
        spaceBetween: 30
    });

    var brandSwiper = new Swiper('.swiper-container-brands', {
        pagination: '.swiper-pagination-brands',
        paginationClickable: true,
        nextButton: '.swiper-button-next-brands',
        prevButton: '.swiper-button-prev-brands',
        spaceBetween: 30,
        slidesPerView: 3,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30
            }
        }
    });
})
